import React, { useEffect } from 'react';
import { useForm } from 'react-hook-form';
import { useDispatch } from 'react-redux';
import { CustomTextFieldInput, CustomFormControl } from '_components';
import { alertActions, userProfileAction } from '_store';
import { Typography, Button, Box } from '@mui/material';
import Popper from '@mui/material/Popper';
import Grid from "@material-ui/core/Grid";
import FilterListIcon from '@mui/icons-material/FilterList';
import { saveFiltersToLocalStore } from '_utils/searchFilterLocalStorage';
import { ERR_MSG } from 'constants/labels';

const UserFilter = ({ isOpen, header,onClose, onOpen, portalsList, handleFilterSubmit, handleportal, portalId, changePortalName, userMgmtListFilterParams, setUserMgmtListFilterParams }) => {
    const dispatch = useDispatch();
    const [anchorEl, setAnchorEl] = React.useState(null);
    const handleClick = (event) => {
        setAnchorEl(event.currentTarget);
        if (isOpen) {
            onClose();
        } else {
            onOpen();
        }
    };
    const canBeOpen = isOpen && Boolean(anchorEl);
    const id = canBeOpen ? 'simple-popper' : undefined;
    const { register, handleSubmit, control, reset,watch, formState: { errors }, trigger } = useForm({
        mode: 'onBlur',
        defaultValues: {
            email: '',
            fullName: ''
        }
    });
    const watchedFields = watch();
    const isSearchEnabled = !!(watchedFields.email || watchedFields.fullName);
    const onSubmit = async (data) => {
      const dataWithPortalId = { ...data, PortalId: portalId };

      try {
        dispatch(alertActions.clear());
        const result = await dispatch(
          userProfileAction.filter(dataWithPortalId),
        ).unwrap();
        handleFilterSubmit(result?.Data);
      } catch (error) {
        handleFilterSubmit(null);
        if (error.message) {
          dispatch(
            alertActions.error({
              message: error.message ? ERR_MSG["073"] : error,
              header,
            }),
          );
        }
      } finally {
        dataWithPortalId && setUserMgmtListFilterParams(dataWithPortalId);
        onClose();
      }
    };

    const handleCancelClick = () => {
        onClose();
    };

    const handleBlur = async (e) => {
        const fieldName = e.target.name;
        await trigger(fieldName);
    };

    useEffect(() => {
      saveFiltersToLocalStore("userManagementList", userMgmtListFilterParams);
    }, [userMgmtListFilterParams]);

    useEffect(() => {
      reset(
        userMgmtListFilterParams ?? {
          email: "",
          fullName: "",
        },
      );
    }, [userMgmtListFilterParams, reset]);

    return (
        <>
            <Button className='Filter' type="button" variant="contained" color="primary" aria-describedby={id} onClick={handleClick}>
                <FilterListIcon />Filter
            </Button>
           
            <Popper id={id}  open={canBeOpen} anchorEl={anchorEl} className="Filtercontainer">
                <Box sx={{ border: 1, p: 1, bgcolor: 'background.paper' }} className="Filtercontainerinner Border">
                    <form onSubmit={handleSubmit(onSubmit)} className='Registrationcontainer'>
                        <Typography component="div" className='userprofilelist'>
                            <Grid container direction="row" spacing={{ xs: 2, md: 3 }}>
                                <Grid item xs={12} sm={6} md={6}>
                                    <Typography variant="h2" className='userprofilelistcontent'>User Profile</Typography>
                                </Grid>
                            </Grid>
                        </Typography>
                        {/* <Typography component="div" className='marbottom0 selecticon '>
                            <AutocompleteInput
                                control={control}
                                name="PortalId"
                                value={selectedPortId}
                                label="Select Portal"
                                options={portalData}
                                error={!!errors.PortalId}
                                helperText={errors.PortalId?.message}
                                handleBlur={handleBlur}
                                trigger={trigger}
                                onChange={handlePortalchange}
                            />
                        </Typography> */}
                        <CustomFormControl

                            id="email"
                            label="Email Address"
                            type="text"
                            required={false}
                            register={register}
                            errors={errors}
                            handleBlur={handleBlur}
                        />
                        <CustomTextFieldInput
                            control={control}
                            name="fullName"
                            label="Full Name"
                        />

                        <Typography component="div" className="CreateMarketerbutton">
                            <Button
                                type="submit"
                                variant="contained"
                                className='submitbutton'
                                color="primary"
                                disabled={!isSearchEnabled}
                            >
                                Search
                            </Button>
                            <Button
                                variant="contained"
                                color="secondary"
                                className="cancelbutton"
                                onClick={handleCancelClick}
                            >
                                Cancel
                            </Button>
                        </Typography>
                    </form>
                </Box>
            </Popper>
           
        </>
    );
}

export default UserFilter;